export const ATOMIC = "atomic";
export const OEMBED_CONTENT_TYPE = "draft-js-oembed";
export const OEMBED_ADD_FORM_TYPE = "draft-js-oembed-form";
